import React, { useEffect, useState } from "react";
import { Modal, Table, message, Grid } from "antd";
import "../../crmSharedStyle.css";
import {
  fetchMetaPageFormsApi,
  saveMetaFormsApi,
} from "../../../../apiservice/crm";

const MetaFormsModal = ({ open, integration, onClose, onSaved }) => {
  const screens = Grid.useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const loadForms = async () => {
    if (!integration?.id) return;
    try {
      setLoading(true);
      const res = await fetchMetaPageFormsApi(integration.id);
      const forms = res?.data?.forms || [];
      setRows(forms);
      setSelectedRowKeys(
        forms.filter((f) => f.connected && f.crm_status === "active").map((f) => f.form_id)
      );
    } catch (err) {
      message.error("Failed to load Meta forms");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && integration?.id) {
      loadForms();
    }
  }, [open, integration?.id]);

  const handleSave = async () => {
    try {
      setSaving(true);

      const selectedForms = rows
        .filter((row) => selectedRowKeys.includes(row.form_id))
        .map((row) => ({
          form_id: row.form_id,
          form_name: row.form_name,
          status: "active",
        }));

      await saveMetaFormsApi({
        integration_id: integration.id,
        forms: selectedForms,
      });

      message.success("Meta forms saved successfully");
      onSaved?.();
      onClose?.();
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Failed to save Meta forms"
      );
    } finally {
      setSaving(false);
    }
  };

  const columns = [
    {
      title: "Form Name",
      dataIndex: "form_name",
      key: "form_name",
    },
    {
      title: "Form ID",
      dataIndex: "form_id",
      key: "form_id",
    },
    {
      title: "Meta Status",
      dataIndex: "meta_status",
      key: "meta_status",
      render: (v) => v || "-",
    },
  ];

  return (
    <Modal
      open={open}
      destroyOnClose
      onCancel={onClose}
      onOk={handleSave}
      okText="Save Forms"
      confirmLoading={saving}
      width={screens.md ? 900 : "95%"}
      className="crm-modal-responsive"
      title={`Manage Meta Forms — ${integration?.page_name || ""}`}
    >
      <Table
        rowKey="form_id"
        loading={loading}
        dataSource={rows}
        columns={columns}
        pagination={false}
        scroll={{ x: "max-content" }}
        rowSelection={{
          selectedRowKeys,
          onChange: setSelectedRowKeys,
        }}
      />
    </Modal>
  );
};

export default MetaFormsModal;